import React from "react";
import LoginSessionsSection from "../../Sections/LoginSessions";
import Dashboard from "../Dashboard/Dashboard";

const LoginSessionsComponent = () => {
    return (
        <Dashboard sectionName={<LoginSessionsSection />}/>
    );
};

export default LoginSessionsComponent;
